import React, { useState } from "react";
import { Container, Row, Col, Tabs, Tab } from "react-bootstrap";
import SectionTitle from "../../../common/SectionTitle/SectionTitle";
import HomeFeatureTab from "../HomeFeatureTab/HomeFeatureTab";
import homeFeaturesData from "../../../../data/homeFeaturesData";
import { useTranslation } from "react-i18next";
import "./HomeFeaturesSection.css";

export default function HomeFeaturesSection() {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState(homeFeaturesData[0].id);

  return (
    <section className="home-features-section section-spacing">
      <Container fluid>
        <div className="text-center">
          <SectionTitle
            subtitle={t("common.sectionTitles.homeTechnologySecSubtitle")}
            title={t("common.sectionTitles.homeTechnologySecTitle")}
          />
        </div>

        <p className="brand-section-desc text-center mb-0">
          {t("common.staticTexts.homeTechDescOne")}
        </p>

        <p className="brand-section-desc text-center">
          {t("common.staticTexts.homeTechDescTwo")}
        </p>

        <Row>
          <Col lg={12}>
            <Tabs
              id="home-features-tabs"
              activeKey={activeKey}
              onSelect={(k) => setActiveKey(k)}
              className="home-features-tabs"
              justify
            >
              {homeFeaturesData.map((feature) => (
                <Tab
                  key={feature.id}
                  eventKey={feature.id}
                  title={t(feature.titleKey)}
                  tabClassName="home-features-tab-title"
                >
                  <div className="home-features-tab-content">
                    <HomeFeatureTab
                      imageSrc={feature.imageSrc}
                      titleKey={feature.titleKey}
                      descriptionKey={feature.descriptionKey}
                      tabSubtitleKey={feature.tabSubtitleKey}
                      tabTitleKey={feature.tabTitleKey}
                    />
                  </div>
                </Tab>
              ))}
            </Tabs>
          </Col>
        </Row>
      </Container>
    </section>
  );
}